import { createContext } from 'react';

const FormContext = createContext();
FormContext.displayName = 'FormContext';

export default FormContext;
